import { motion } from "framer-motion";
import { SOCIALS } from "@/lib/socials";

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="border-t border-white/10 px-6 md:px-12 pt-24 pb-10 overflow-hidden"
    >
      <motion.h2
        data-testid="footer-brand"
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 1.2, ease: [0.16, 1, 0.3, 1] }}
        className="font-serif-display font-semibold text-[18vw] leading-[0.8] tracking-tighter text-center whitespace-nowrap text-transparent bg-clip-text bg-gradient-to-r from-[#34D399] via-[#7DD3FC] to-[#38BDF8]"
      >
        ROSTENO
      </motion.h2>
      <div
        data-testid="social-links"
        className="mt-14 flex items-center justify-center gap-4"
      >
        {SOCIALS.map((social) => (
          <a
            key={social.name}
            data-testid={`social-${social.name.toLowerCase()}`}
            href={social.href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`${social.name} — ${social.handle}`}
            title={`${social.name} — ${social.handle}`}
            className="group flex items-center justify-center w-12 h-12 rounded-full border border-white/15 text-[#8B99AE] transition-colors duration-300 hover:border-[#4ADE80] hover:text-[#4ADE80]"
          >
            <svg viewBox="0 0 24 24" className="w-4.5 h-4.5 fill-current" width="18" height="18" aria-hidden="true">
              <path d={social.path} />
            </svg>
          </a>
        ))}
      </div>
      <div className="mt-10 flex flex-col sm:flex-row items-center justify-between gap-6 font-mono-accent text-xs uppercase tracking-[0.2em] text-[#8B99AE]">
        <span data-testid="footer-copyright">© 2026 Rosteno</span>
        <div className="flex items-center gap-8">
          <a
            data-testid="footer-privacy-link"
            href="#"
            className="transition-colors duration-300 hover:text-white"
          >
            Privacy
          </a>
          <a
            data-testid="footer-terms-link"
            href="#"
            className="transition-colors duration-300 hover:text-white"
          >
            Terms
          </a>
          <a
            data-testid="footer-contact-link"
            href="mailto:admin@rosteno.com"
            className="transition-colors duration-300 hover:text-white"
          >
            Contact
          </a>
        </div>
      </div>
    </footer>
  );
}
